import moment, {type DurationInputArg1} from 'moment';
import { StateSetter } from 'types/utils/React';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';

const useStyles = makeStyles(() => ({
  bar: {
    userSelect: 'none',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  time: {
    color: COLORS.WHITE,
    fontSize: 12,
  },
  progress: {
    flex: 1,
    borderRadius: 5,
    margin: '0 10px',
    height: 6,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  progressKnob: {
    position: 'relative',
    height: 8,
    width: 8,
    border: `1.5px solid ${COLORS.WHITE}`,
    borderRadius: '50%',
    backgroundColor: COLORS.ORANGE,
  },
}), { name: 'ProgressBar' });

const formatDuration = (duration : DurationInputArg1) => {
  const momentDuration = moment.duration(duration, 'seconds');

  return moment.utc(momentDuration.asMilliseconds()).format('mm:ss');
};

export type ProgressBarProps = {
  id: string;
  duration: number;
  curTime: number;
  onTimeUpdate: StateSetter<number>;
};

const ProgressBar = ({
  id,
  duration,
  curTime,
  onTimeUpdate,
}: ProgressBarProps) => {
  const curPercentage = (curTime / duration) * 100;
  const barProgressId = `bar-progress-${id}`;

  const calcClickedTime = (e) => {
    const clickPositionInPage = e.pageX;
    const bar : HTMLElement = document.querySelector(`#${barProgressId}`) ;

    if (bar) {
      const barStart = bar.getBoundingClientRect().left + window.scrollX;
      const barWidth = bar.offsetWidth;
      const clickPositionInBar = clickPositionInPage - barStart;
      const timePerPixel = duration / barWidth;

      return timePerPixel * clickPositionInBar;
    }
  };

  const handleTimeDrag = (e) => {
    onTimeUpdate(calcClickedTime(e));

    const updateTimeOnMove = (eMove) => {
      onTimeUpdate(calcClickedTime(eMove));
    };

    document.addEventListener('mousemove', updateTimeOnMove);

    document.addEventListener('mouseup', () => {
      document.removeEventListener('mousemove', updateTimeOnMove);
    });
  };

  const classes = useStyles();

  return (
    <div className={classes.bar}>
      <span className={classes.time}>{formatDuration(curTime)}</span>
      <div
        className={classes.progress}
        id={barProgressId}
        style={{
          background: `linear-gradient(to right, ${COLORS.ORANGE} ${curPercentage}%, ${COLORS.WHITE} 0)`,
        }}
        onMouseDown={handleTimeDrag}
      >
        <span
          className={classes.progressKnob}
          style={{ left: `${curPercentage - 2}%` }}
        />
      </div>
      <span className={classes.time}>{formatDuration(duration)}</span>
    </div>
  );
};

export default ProgressBar;
